//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_passOpaque = 7.0;\n\
";
